<template>
  <footer class="">
      <div class="ly_footer">
          <div class="ly_footer_inner">
              <div class="footer">
                  <p class="footer_imgWrap">
                      <img :src="`${dir}/src/assets/img/yusuugaku-logo-gold.svg`"
                           alt="yusuugaku 由数学"
                           class="footer_img">
                  </p>
                  <nav class="footerNav mt-40 mt-md-60 mt-lg-80">
                      <ul class="footerNav_list ff_serif">
                          <li class="footerNav_item">
                              <router-link to="/" class="footerNav_link link-light">Home</router-link>
                          </li>
                          <li class="footerNav_item">
                              <router-link to="/greeting" class="footerNav_link link-light">ご挨拶</router-link>
                          </li>
                          <li class="footerNav_item">
                              <router-link to="/branch-introduction" class="footerNav_link link-light">各支部校</router-link>
                          </li>
                          <li class="footerNav_item">
                              <router-link to="/contact" class="footerNav_link link-light">お問い合わせ</router-link>
                          </li>
                          <li class="footerNav_item">
                              <router-link to="/sign-in" class="footerNav_link link-light">SignIn</router-link>
                          </li>
                      </ul>
                      <p class="mt-50 mt-lg-80 d-flex justify_content_center">
                          <router-link to="/entry-pre-seminar" class="el_btnA">ENTRY</router-link>
                      </p>
                  </nav>
                  <p class="mt-50 text-white-50">
                      <small>&copy;&nbsp;2022&nbsp;由数学協会</small>
                  </p>
              </div>
          </div>
      </div>
      <PageTopBtn/>
  </footer>
</template>

<script>
import PageTopBtn from './PageTopBtn';
export default {
    data() {
        return {
            dir: DIR,
        }
    },
    components: {
        PageTopBtn,
    },
    mounted() {
    },
}
</script>

<style scoped lang="scss" src="../../assets/scss/modules/footer.scss">
</style>
